import { ChangeDetectionStrategy, Component, input, output } from "@angular/core";
import { Button, Icon } from "@ui";

// A single "next step" option in the ingest modal action view.
@Component({
  selector: "app-ingest-action-card",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [Button, Icon],
  styleUrls: ["./action-card.component.scss"],
  template: `
    <div class="p-card p-h-full p-flex-col-sm p-p-md">
      <div class="p-flex-col-xs p-flex-grow-1">
        <div class="action-card__icon p-flex p-flex-center p-p-xs p-rounded-lg">
          <p-icon-lg [icon]="icon()" />
        </div>
        <span class="p-text-title-sm p-color-text-secondary">{{ title() }}</span>
        <span class="p-text-desc p-color-text-secondary">{{ description() }}</span>
      </div>
      <div class="p-flex-col-xs p-flex-start">
        @if (disabledReason()) {
          <span class="p-text-footnote p-color-error">{{ disabledReason() }}</span>
        }
        <p-button-secondary-sm [disabled]="disabled()" [loading]="loading()" (click)="action.emit()">
          {{ actionLabel() }}
          <p-icon icon="arrow_right" />
        </p-button-secondary-sm>
      </div>
    </div>
  `,
})
export class IngestActionCardComponent {
  readonly icon = input.required<string>();
  readonly title = input.required<string>();
  readonly description = input.required<string>();
  readonly actionLabel = input.required<string>();
  readonly disabled = input(false);
  readonly loading = input(false);
  // explains why the action is unavailable; empty means the action is available
  readonly disabledReason = input("");

  readonly action = output<void>();
}
